import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dap_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("dap_token");
      localStorage.removeItem("dap_user");
      if (!window.location.pathname.match(/^\/(login|register|)$/)) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

// ==== Typed helpers ====
export const authApi = {
  register: (payload) => api.post("/auth/register", payload).then((r) => r.data),
  login: (payload) => api.post("/auth/login", payload).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
};

export const projectsApi = {
  list: () => api.get("/projects").then((r) => r.data),
  get: (id) => api.get(`/projects/${id}`).then((r) => r.data),
  create: (p) => api.post("/projects", p).then((r) => r.data),
  update: (id, p) => api.put(`/projects/${id}`, p).then((r) => r.data),
  remove: (id) => api.delete(`/projects/${id}`).then((r) => r.data),
};

export const documentsApi = {
  list: (projectId) => api.get(`/projects/${projectId}/documents`).then((r) => r.data),
  get: (projectId, docId) => api.get(`/projects/${projectId}/documents/${docId}`).then((r) => r.data),
  upload: (projectId, files) => {
    const form = new FormData();
    Array.from(files).forEach((f) => form.append("files", f));
    return api.post(`/projects/${projectId}/documents/upload`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  updateData: (projectId, docId, data) =>
    api.put(`/projects/${projectId}/documents/${docId}/data`, data).then((r) => r.data),
  remove: (projectId, docId) =>
    api.delete(`/projects/${projectId}/documents/${docId}`).then((r) => r.data),
};

export const analysesApi = {
  summary: (pid) => api.get(`/projects/${pid}/analyses/summary`).then((r) => r.data),
  macro: (pid) => api.get(`/projects/${pid}/analyses/macro`).then((r) => r.data),
  vitaliste: (pid) => api.get(`/projects/${pid}/analyses/vitaliste`).then((r) => r.data),
  clauses: (pid) => api.get(`/projects/${pid}/analyses/clauses`).then((r) => r.data),
  odd: (pid) => api.get(`/projects/${pid}/analyses/odd`).then((r) => r.data),
  legal: (pid) => api.post(`/projects/${pid}/analyses/legal`).then((r) => r.data),
  simulate: (pid, inputs) =>
    api.post(`/projects/${pid}/simulate`, { project_id: pid, ...inputs }).then((r) => r.data),
};

export const qaApi = {
  list: (pid) => api.get(`/projects/${pid}/qa`).then((r) => r.data),
  ask: (pid, question) => api.post("/qa", { project_id: pid, question }).then((r) => r.data),
};

export const vitaeApi = {
  sync: (pid) => api.post(`/projects/${pid}/vitae-publica/sync`).then((r) => r.data),
  history: (pid) => api.get(`/projects/${pid}/vitae-publica/history`).then((r) => r.data),
  receive: (pid, payload) => api.post(`/projects/${pid}/vitae-publica/receive`, payload).then((r) => r.data),
};
